import { ContentAssetID } from '../../utils/api/ContentAssetID';

export const preloadContentAssets: string[] = [
    ContentAssetID.BRANDS_A_E.valueOf(),
    ContentAssetID.BRANDS_F_J.valueOf(),
    ContentAssetID.BRANDS_K_O.valueOf(),
    ContentAssetID.BRANDS_P_T.valueOf(),
    ContentAssetID.BRANDS_U_123.valueOf(),
    'terms_and_conditions',
    'privacy-policy',
];
